// ENUMS in order of specificity
export enum AutomationPlacement {
    MODAL = 'modal',
    HOME_PAGE = 'home_page',
    SITE_HEADER = 'site_header',
    SITE_FOOTER = 'site_footer',
    BLOG_CATEGORY_PAGE = 'blog_category_page',
    BLOG = 'blog',
    SEARCH_PAGE = 'search_page',
    NEWSROOM_ARCHIVE_PAGE = 'newsroom_archive_Page',
    CALCULATOR_PAGE = 'calculator_page'
}
export enum AutomationTestIdFeature {
    SEARCH = 'search',
    LOGIN = 'login',
    WEALTH_ADVISOR_LOOKUP = 'wealth_advisor_lookup',
    EMPLOYEE_LOOKUP = 'employee_lookup',
    NEWSROOM_FEATURED = 'newsroom_featured',
    NEWSROOM_SEARCH = 'newsroom_search',
    PAYMENT_CALCULATOR = 'payment_calculator',
    VEHICLE_PAYMENT_CALCULATOR = 'vehicle_payment_calculator',
    BRANCH_LOCATOR = 'branch_locator',
    MRQT_CALCULATOR = 'mrqt_calculator',
    HERO = 'hero',
    FORM = 'form',
    TOOLTIP = 'tooltip',
    IMAGE_COLUMN = 'image_column',
    TEXT_PARALLAX = 'text_parallax',
    TWO_IMAGES_PARALLAX = 'two_images_parallax',
    CARD_DECK = 'card_deck',
}
export enum AutomationTestIdElementType {
    BUTTON = 'button',
    INPUT = 'input',
    LINK = 'link',
    IMAGE = 'image',
    VIDEO = 'video',
    COLLECTION = 'collection',
    COLLECTION_ITEM = 'collection_item',
    SELECT = 'select',
    CONTAINER = 'container',
    TEXT = 'text',
    FORM = 'form',
    DROPDOWN = 'dropdown',
    DROPDOWN_ITEM = 'dropdown_item'
}

export interface AutomationTestIdOptions {
    placement?: AutomationPlacement,
    feature?: AutomationTestIdFeature,
    element?: AutomationTestIdElementType,
    specifier?: string,
}
export const createDataTestId = ({placement, feature, element, specifier}: AutomationTestIdOptions):string => {
    // example return value (with no specifier): "home_page-search-button"
    // example return value (with optional specifier): "home_page-search-button-header" (specifier for more specificity)
    const dataTestFields = [placement, feature, element, specifier].filter(item => Boolean(item));

    // At least two options are required
    if (dataTestFields.length < 2) {
        throw ("createDataTestId: at least 2 parameters are required");
    }
    return dataTestFields.join('-');
}